import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers";
import { LangType } from "src/app/types/LangType";

const CellFlag = ({ lang }: { lang?: LangType }) => {
    if (!lang) return <></>;
    return <SVG width={16} src={toAbsoluteUrl(`/media/flags/${lang.toLowerCase()}.svg`)} />;
};

export default CellFlag;
